import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ContainerService from '../../../../services/ContainerService';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import { Breadcrumbs, Button, Card, Input } from '../../../../components/UI/ComponentsUI';
import { ENUMS } from '../../../../utils/constants';

const ExecutionSchedule = (props) => {
    let type = props.location?.state?.type;

    const [lowHours, setLowHours] = useState([]);
    const [time, setTime] = useState();

    const onConfirm = () => {
        if (lowHours.length > 0) {
            props.addScheduleCalculation(lowHours, () => {
                props.history.go(-1);
            })
        }
    };

    const addItem = () => {
        if (!isNullOrEmpty(time)) {
            if (lowHours.some((element) => element.time === time)) {
                document.getElementById('time').focus();
                return showMessageToastCustom(translate('warning', 'general'), "Hora ja inserida!", 3000, 'mdi mdi-alert-circle-outline red-text');
            }
            lowHours.push({
                type: type,
                time: time
            })
            setTime();
            setLowHours([...lowHours])
            document.getElementById('time').value = '';
            document.getElementById('time').focus();
        }
    }

    const removeItem = (item) => {
        const findIndex = lowHours.indexOf(item)
        lowHours.splice(findIndex, 1);
        setLowHours([...lowHours])
    }

    return (
        <div>
            <Breadcrumbs id="insertTimes" title={{
                icon: "mdi mdi-clipboard-check-outline",
                label: type === ENUMS.eTypeScheduleCalculation.Coverage.value
                    ? translate('container:config:execution-calculation.coverage-execution-times') : translate('container:config:execution-calculation.spawn-list-execution-times')
            }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <form id="formMovementTypeInsert">
                            <div className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s9">
                                    <Input
                                        type="time"
                                        defaultValue={time}
                                        onChange={(event) => setTime(event.target.value)}
                                        label={translate('stock:low-hours')}
                                        id="time"
                                        name="time"
                                    />
                                </div>
                                <div className="col s2" style={{ paddingTop: '10px' }}>
                                    <button
                                        className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                        type="button"
                                        onClick={() => addItem()}
                                    >
                                        <i className={`mdi mdi mdi-plus`} />
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div className="row" style={{ paddingTop: '10px' }}>
                            {
                                lowHours.length > 0 && lowHours.map((item, index) => (
                                    <div key={item.time + index} className="no-padding col s12">
                                        <div key={item.time + 1} className="list sixth-text-color">
                                            <i onClick={() => removeItem(item)} className={`mdi mdi-21px mdi-alpha-x-circle-outline`} />
                                            {`${item.time}`}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="row" style={{ paddingTop: '10px' }}>
                            <div className="col s6">
                                <Button full="true" onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            </div>
                            <div className="col s6">
                                <Button full="true" onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </Card>
                </div>
            </div >
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addScheduleCalculation: (data, callback) => {
            dispatch(ContainerService.addScheduleCalculation(data, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ExecutionSchedule)));
